import { Injectable } from '@angular/core';
import { UserService } from '../services/user.service';
import { map } from 'rxjs/operators';


@Injectable()
export class PoliciesResolver  {

  constructor(private userService: UserService) {}

  resolve() {
    return this.userService.getPolicies(0, 50)
      .pipe(
        map(result => result)
      );
  }
}
